import React, { useContext } from 'react';
import ControlButton from './components/ControlButton';
import { DevicesNotificationTypes } from 'types';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from 'modules/Devices/DeviceFullInfo/deviceFullInfoState/deviceFullInfoContext';
import style from './Controls.module.scss';

const Controls: React.FC = () => {
	const { changeTypeOfModalWindow, setDataForPush, deviceForFullInfo } =
		useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	const handlePush = (notificationType: DevicesNotificationTypes) => {
		if (deviceForFullInfo?.restaurantId && deviceForFullInfo.hardwareId) {
			changeTypeOfModalWindow('confirm');
			const { restaurantId, hardwareId } = deviceForFullInfo;
			setDataForPush({
				hardwareId,
				data: {
					restaurantId,
					notificationType,
				},
			});
		}
	};

	const handleDropboxPush = () => {
		changeTypeOfModalWindow('dropBoxPush');
	};

	return (
		<div className={style.container} data-test="Controls">
			<div className={style.wrapper}>
				<ControlButton
					label="deactivateDevice"
					onClick={() => handlePush(DevicesNotificationTypes.PushDeactivateDevice)}
				/>
				<ControlButton
					label="pushUpdateAllSettings"
					onClick={() => handlePush(DevicesNotificationTypes.PushUpdateAllSettings)}
				/>
				<ControlButton
					label="pushUpdateMainSettings"
					onClick={() => handlePush(DevicesNotificationTypes.PushUpdateMainSettings)}
				/>
				<ControlButton
					label="pushUpdateGames"
					onClick={() => handlePush(DevicesNotificationTypes.PushUpdateGames)}
				/>
				<ControlButton
					label="pushUpdateTeasers"
					onClick={() => handlePush(DevicesNotificationTypes.PushUpdateTeasers)}
				/>
				<ControlButton
					label="pushUpdateConfigurationFile"
					onClick={() => handlePush(DevicesNotificationTypes.PushUpdateConfigurationFile)}
				/>
				<ControlButton
					label="pushUpdateRestaurantSettings"
					onClick={() => handlePush(DevicesNotificationTypes.PushUpdateRestaurantSettings)}
				/>
				<ControlButton
					label="pushUpdateRestaurantMenu"
					onClick={() => handlePush(DevicesNotificationTypes.PushUpdateRestaurantMenu)}
				/>
				<ControlButton label="pushCloseDay" onClick={() => handlePush(DevicesNotificationTypes.PushCloseDay)} />
				<ControlButton
					label="pushRestartApp"
					onClick={() => handlePush(DevicesNotificationTypes.PushRestartApp)}
				/>
				<ControlButton
					label="pushDownloadFirmware"
					onClick={() => handlePush(DevicesNotificationTypes.PushDownloadFirmware)}
				/>
				<ControlButton
					label="pushRebootDevice"
					onClick={() => handlePush(DevicesNotificationTypes.PushRebootDevices)}
				/>
				<ControlButton
					label="pushShutdownDevice"
					onClick={() => handlePush(DevicesNotificationTypes.PushShutdownDevices)}
				/>
				<ControlButton
					label="pushUpdateEncryptedPaymentConfig"
					onClick={() => handlePush(DevicesNotificationTypes.PushUpdateEncryptedPaymentConfig)}
				/>
				<ControlButton
					label="pushUpdateLauncherConfig"
					onClick={() => handlePush(DevicesNotificationTypes.PushUpdateLauncherConfig)}
				/>
				<ControlButton label="dropboxPush" onClick={handleDropboxPush} />
				<ControlButton
					label="pushUpdateVideos"
					onClick={() => handlePush(DevicesNotificationTypes.PushUpdateVideos)}
				/>
				<ControlButton
					label="pushDmsNetworkParams"
					onClick={() => handlePush(DevicesNotificationTypes.PushDmsNetworkParams)}
				/>
				<ControlButton
					label="pushSendThirdPartyLogs"
					onClick={() => handlePush(DevicesNotificationTypes.PushSendThirdPartyLogs)}
				/>
				<ControlButton
					label="pushRestaurantMenu"
					onClick={() => handlePush(DevicesNotificationTypes.PushRestaurantMenu)}
				/>
			</div>
		</div>
	);
};

export default Controls;
